import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { LOGO, scrollToId } from "@/lib/assets";
import { useLang, LANGS } from "@/lib/i18n";

const scrollTo = scrollToId;

const linkIds = ["modes", "how", "resenha", "sports"];

export default function Nav() {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-[#0A0A0A]/90 backdrop-blur-md border-white/10" : "border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button onClick={() => scrollTo("top")} data-testid="nav-logo" className="flex items-center">
          <img src={LOGO} alt="PINWIN" className="h-7 md:h-9 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {linkIds.map((id) => (
            <button
              key={id}
              onClick={() => scrollTo(id)}
              data-testid={`nav-link-${id}`}
              className="font-mono-pw uppercase text-xs tracking-[0.2em] text-white/60 hover:text-[#E6FF00] transition-colors"
            >
              {t.nav[id]}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3 md:gap-5">
          <div className="flex items-center border border-white/15" data-testid="lang-switcher">
            {LANGS.map((l) => (
              <button
                key={l.code}
                onClick={() => setLang(l.code)}
                data-testid={`lang-${l.code}`}
                className={`font-mono-pw text-[11px] tracking-[0.1em] px-2.5 py-1.5 transition-colors ${
                  lang === l.code ? "bg-[#E6FF00] text-black" : "text-white/50 hover:text-white"
                }`}
              >
                {l.label}
              </button>
            ))}
          </div>

          <button
            onClick={() => scrollTo("reserve")}
            data-testid="nav-reserve-btn"
            className="font-mono-pw uppercase text-xs tracking-[0.15em] bg-[#E6FF00] text-black px-4 md:px-6 py-2.5 font-semibold hover:-translate-y-0.5 transition-transform duration-200 shadow-[3px_3px_0px_rgba(230,255,0,0.25)]"
          >
            {t.nav.claim}
          </button>
        </div>
      </div>
    </motion.header>
  );
}
